import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineL } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Section, StyledContainer, Title } from '../ui';

const Layout = styled(Horizontal).attrs({ gap: 8 })`
  align-items: flex-start;
  flex-wrap: wrap;
`;

const ValueContainer = styled.div`
  min-height: 1.5em;
  margin: revert;
  @media ${tabletAndAbove} {
    max-width: calc((100% - 8 * var(--unit)) / 2);
  }
`;

export const Values = () => {
  return (
    <Section $spacing>
      <StyledContainer>
        <Title>Our Values</Title>
        <Layout>
          <ValueContainer>
            <HeadlineL as="h3">Own Your Game</HeadlineL>
            <BodyM bold>
              Think and act like an owner, and expect your teammates to do the
              same.
            </BodyM>
            You are an entrepreneur empowered to make decisions and own the
            outcomes. Demand excellence from yourself and your teammates in
            order to own and change the game. See beyond your own work and keep
            the long view for Sorare and the fans.
          </ValueContainer>
          <ValueContainer>
            <HeadlineL as="h3">Build with the fans, and for the fans</HeadlineL>
            <BodyM bold>
              Have an obsession for high-quality user experiences.
            </BodyM>
            Always seek opportunities to delight customers and turn them into
            Sorare fans. Engage our community with transparency to build trust,
            and learn from the fans to deliver effective changes. Do everything
            you can to retain and reward the trust they put in us.
          </ValueContainer>
          <ValueContainer>
            <HeadlineL as="h3">Run Fast</HeadlineL>
            <BodyM bold>
              Take bold risks and outpace the competition. Have a bias for
              action (connected to team goals) and strive to ship and iterate.
            </BodyM>
            Deliver something real today - and learn from it - rather than
            delivering something of questionably better quality next week.
            Expect and embrace failure as a path toward success, and only make
            new mistakes.
          </ValueContainer>
          <ValueContainer>
            <HeadlineL as="h3">Have fun and Bring joy</HeadlineL>
            <BodyM>
              Sports have the power to unite people around the world, and as
              fans ourselves, we believe it is a privilege to work in this
              industry. By loving what we do, we can build a superior product
              and a more joyful world. That is how Sorare will build a timeless
              brand.
            </BodyM>
          </ValueContainer>
          <ValueContainer>
            <HeadlineL as="h3">Win as a Team</HeadlineL>
            <BodyM>
              We are all in this together as one team, win or lose. Coach and
              inspire your teammates to be better. Sorare is not a place for
              politics, but rather a collective where team members share the
              same passion for the game and limitless ambition, grounded in
              humility, to drive the company and product forward. Sorare
              employees all have an equal opportunity to participate and
              cultivate change, without the burden of hierarchy.
            </BodyM>
          </ValueContainer>
        </Layout>
      </StyledContainer>
    </Section>
  );
};
